import {Button} from "@material-ui/core"
import ArrowBackIcon from "@material-ui/icons/ArrowBack"
import {useNavigate} from "react-router-dom"
import React from "react"

function BackToSearch({backURL}: {backURL?: string | null}): JSX.Element | null {
	const navigate = useNavigate()
	if (backURL) {
		return (
			<Button
				variant="text"
				size="small"
				style={{padding: 0}}
				startIcon={<ArrowBackIcon />}
				onClick={() => navigate(backURL)}
			>
				Back
			</Button>
		)
	}

	return null
}

export {BackToSearch}
